import { useServiceFactory } from '@euler/services/factory';
import { useCallback, useEffect, useState } from 'react';

export type BiEntryState =
  | { kind: 'loading' }
  | { kind: 'failed' }
  | { kind: 'ready'; dashboardId: string | null };

/** Where BI opens for the caller: their default dashboard, or none. */
export function useBiEntry() {
  const { biService } = useServiceFactory();
  const [state, setState] = useState<BiEntryState>({ kind: 'loading' });
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    setState({ kind: 'loading' });
    biService
      .dashboardEntry()
      .then(({ dashboardId }) => {
        if (active) setState({ kind: 'ready', dashboardId });
      })
      .catch(error => {
        console.error('BI entry failed', error);
        if (active) setState({ kind: 'failed' });
      });
    return () => {
      active = false;
    };
  }, [biService, attempt]);
  const retry = useCallback(() => setAttempt(value => value + 1), []);
  return { state, retry };
}
